import * as React from 'react';

import { useSelector } from 'react-redux';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';

import DisplayModal from '../common/DisplayModal';
import SignIn from '../registration/SignIn';
import FixedFooterNav from './FixedFooterNav';

import { NotificationsContext } from '../notifications/NotificationsProvider';

import ZipRunPrivacyPolicy from '../../docs/ZipRunPrivacyPolicy';
import ZipRunTermsOfService from '../../docs/ZipRunTermsOfService';

import zipRunLogoWhite from '../../assets/ZipRunLogoWhiteSm.png';
import zipRunLogoGreen from '../../assets/ZipRunLogoTransSm.png';
import styles from './PageFooter.module.css';

const PageFooter = () => {

  const dispensaryId = useSelector(state => state.dispensaryId);

  const[showTerms, setShowTerms] = React.useState();
  const[showPrivacy, setShowPrivacy] = React.useState();
  
  // Used by the account link to require sign in
  const [showLoginModal, setShowLoginModal] = React.useState();

  // Notifications
  const { notifications, viewedIds } = React.useContext(NotificationsContext);
  
  return (
    <> 
      <div id="footer" className={styles.pageFooter}>
        { showTerms &&
          <DisplayModal scrollingInner title="Terms of Service" closeFn={() => setShowTerms(false)}>
            <ZipRunTermsOfService />
          </DisplayModal>
        }
   
        { showPrivacy &&
          <DisplayModal scrollingInner title="Zip Run Privacy Policy" closeFn={() => setShowPrivacy(false)}>
            <ZipRunPrivacyPolicy />
          </DisplayModal>
        }
  
        <img alt="" className={`${styles.zrLogo} ${styles.logoWhite}`} src={zipRunLogoWhite} />
        <img alt="" className={`${styles.zrLogo} ${styles.logoGreen}`} src={zipRunLogoGreen} />
        
        <span className={styles.contentLinks}>
          <span className={styles.contentLink} onClick={() => setShowTerms(true)}>Terms of Service</span>
          <span className={styles.contentLink} onClick={() => setShowPrivacy(true)}>Privacy Policy</span>
        </span>
  
        <span className={styles.copyright}>&copy; {new Date().getFullYear()} Zip Run</span> 
        <span className={styles.socialIcons}>
          <a className={styles.socialLink} target="_blank" rel="nofollow noopener noreferrer" href="https://www.facebook.com/ziprunofficial">
            <FacebookIcon />
          </a>
          <a className={styles.socialLink} target="_blank" rel="nofollow noopener noreferrer" href="https://www.instagram.com/ziprunofficial">
            <InstagramIcon />
          </a> 
          <a className={styles.socialLink} target="_blank" rel="nofollow noopener noreferrer" href="https://www.twitter.com/ziprunofficial">
            <TwitterIcon />
          </a>
        </span>
      </div>
      <FixedFooterNav 
        notificationIds={notifications}
        viewedIds={viewedIds}
        handleShowLogin={setShowLoginModal} 
        />
      {/* This instance of the modal is used by the Slide-In-Cart to require Log In prior to check out */}
      { showLoginModal && 
          <DisplayModal showAboveNav closeFn={() => setShowLoginModal(false)}>
            <SignIn title="Sign In" withHeader={false} closeFn={() => setShowLoginModal(false)} 
              navigateTo={`/placeOrder/${dispensaryId}`} />
          </DisplayModal>
        }
    </> 
  );
};

export default PageFooter;